// Appointment Status Options
export const APPOINTMENT_STATUS_OPTIONS = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Scheduled', value: 'SCHEDULED' },
  { label: 'Rescheduled', value: 'RESCHEDULED' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'No Show', value: 'NO_SHOW' },
] as const;

// Service Type Options
export const SERVICE_TYPE_OPTIONS = [
  { label: 'Consultation', value: 'CONSULTATION' },
  { label: 'Treatment', value: 'TREATMENT' },
  { label: 'LHR Treatment', value: 'LHR_TREATMENT' },
  { label: 'Other', value: 'OTHER' },
] as const;

// Patient Status Options
export const PATIENT_STATUS_OPTIONS = [
  { label: 'New', value: 'NEW' },
  { label: 'Old', value: 'OLD' },
] as const;

// Filter Options
export const STATUS_FILTER_OPTIONS = APPOINTMENT_STATUS_OPTIONS.map(option => ({
  label: option.label,
  value: option.value,
}));

export const SERVICE_TYPE_FILTER_OPTIONS = SERVICE_TYPE_OPTIONS.map(option => ({
  label: option.label,
  value: option.value,
}));